import React, { useEffect, useRef } from 'react';
import './static.style.scss';
import { __StaticProps } from './static.interface';
import { ReduxState, TextDirection } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { extractTitle } from 'scripts/string';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
const SLPStatic: React.FC<ConnectedProps<typeof connector> & __StaticProps> = (
    props: ConnectedProps<typeof connector> & __StaticProps,
) => {
    const labelRef = useRef<HTMLLabelElement>(null);

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    return (
        <div className={`ucheck-SLP-static ${props.dir === TextDirection.rtl ? 'rtl-text' : ''}`}>
            <span className="d-flex">
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </span>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(SLPStatic);
